

import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import usedeletedata from '../../Hooks/useDeleteData';
import { Add_Company_Domain, Get_All_Company_Domain, Get_Error, Update_One_Company_Domain } from '../Types';
import { UpdateDatawithimage, UpdateProductdata } from '../../Hooks/useUpdateData';

export const Add_Company_Domain_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/CompanyDomains`, body);

    dispatch({
      type: Add_Company_Domain,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

//get all cities data
export const GetAll_Company_Domains_Action = (quarystring) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/CompanyDomains?${quarystring}`);

    dispatch({
      type: Get_All_Company_Domain,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};













export const UpdateCompanyDomainData = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateDatawithimage(`/api/v1/CompanyDomains/${id}`, body);

    dispatch({
      type: Update_One_Company_Domain, 
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response, // استخدم response مش res
    });
  }
};











// Delete Company Domain (soft delete by setting is_active = false)
export const Delete_Company_Domain_Action = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateDatawithimage(`/api/v1/CompanyDomains/${id}`, body);

    dispatch({
      type: Update_One_Company_Domain,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response,
    });
  }
};